module.exports = __webpack_public_path__ + "img/galeria-ornamentales-3.610aafb9.jpg";